import type { PluginRouteFactory } from "@d12labs/plugins/types";
import { createRoute } from "@tanstack/react-router";
import { lazy } from "react";

const DashboardPage = lazy(() =>
	import("./pages/index.page").then((m) => ({ default: m.IndexPage })),
);
const UploadPage = lazy(() =>
	import("./pages/upload.page").then((m) => ({ default: m.UploadPage })),
);
const MeetingsListPage = lazy(() =>
	import("./pages/meetings-list.page").then((m) => ({ default: m.MeetingsListPage })),
);
const MeetingDetailPage = lazy(() =>
	import("./pages/meeting-detail.page").then((m) => ({ default: m.MeetingDetailPage })),
);
const SpeakersListPage = lazy(() =>
	import("./pages/speakers-list.page").then((m) => ({ default: m.SpeakersListPage })),
);
const SpeakerProfilePage = lazy(() =>
	import("./pages/speaker-profile.page").then((m) => ({ default: m.SpeakerProfilePage })),
);
const CoachingPage = lazy(() =>
	import("./pages/coaching.page").then((m) => ({ default: m.CoachingPage })),
);
const ActivityPage = lazy(() =>
	import("./pages/activity.page").then((m) => ({ default: m.ActivityPage })),
);

export const createPluginRoutes: PluginRouteFactory = (parentRoute) => [
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/meeting-perf/coaching",
		component: CoachingPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/meeting-perf/activity",
		component: ActivityPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/meeting-perf",
		component: DashboardPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/meeting-perf/upload",
		component: UploadPage,
		// Optional ?source=fireflies deep-link from the dashboard's Fireflies CTA.
		validateSearch: (search: Record<string, unknown>): { source?: "fireflies" } => ({
			source: search.source === "fireflies" ? "fireflies" : undefined,
		}),
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/meeting-perf/meetings",
		component: MeetingsListPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/meeting-perf/meetings/$id",
		component: MeetingDetailPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/meeting-perf/speakers",
		component: SpeakersListPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/meeting-perf/speakers/$id",
		component: SpeakerProfilePage,
	}),
];
